import React, { useCallback } from "react";
import { Container, Card } from "react-bootstrap";
import HotelAvailabilityAdmin from "../admin/HotelAvailabilityAdmin";
import { listTeamHotelAvailability } from "../services/leadTrackerApi";

// Teams can look but never change: the backend has no team write endpoint either.
const viewOnly = () => Promise.reject(new Error("Hotel availability is view only"));

export default function HotelAvailabilityPage({ team }) {
  const storageKey = team === "CALL" ? "callTeamToken" : "chatTeamToken";
  const token = localStorage.getItem(storageKey);

  const fetchAvailability = useCallback(
    (startDate, endDate) => listTeamHotelAvailability(team, token, startDate, endDate),
    [team, token],
  );

  if (!token) {
    return (
      <Container fluid className="py-3 px-2 px-sm-3">
        <h4 className="mb-3">Hotel Availability</h4>
        <Card body className="text-center text-muted">
          Please log in to the {team === "CALL" ? "Call" : "Chat"} Team portal in another tab first, then reopen this page.
        </Card>
      </Container>
    );
  }

  return (
    <HotelAvailabilityAdmin
      title="Hotel Availability"
      subtitle="City-wise room availability - view only"
      readOnly
      showOwnerAccess={false}
      showSoldOutActions={false}
      showCopySummary={false}
      fetchAvailability={fetchAvailability}
      updateAvailability={viewOnly}
      markHotelSoldOut={viewOnly}
      undoHotelSoldOut={viewOnly}
    />
  );
}
